import React from "react";
import { FilterQuickKeyFormContextType } from "./types";

export const FilterQuickKeyFormContext = React.createContext<
  FilterQuickKeyFormContextType | undefined
>(undefined);
